import { createCmds } from './cmds.js';
import { createNet } from './net.js';
import { createSys } from './sys.js';
export function createDiag(config) {
  return {
    cmds: createCmds(config),
    net: createNet(config),
    sys: createSys(config)
  };
}